export enum TogglePositionTypes {
  rightTop = 'rt',
  rightBottom = 'rb',
  leftTop = 'lt',
  leftBottom = 'lb',
}
